import {
  Badge,
  Box,
  Card,
  HStack,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react"

interface DiscriminationIndicatorProps {
  discriminationIndex: number
  discriminationLevel: "Excellent" | "Good" | "Poor" | "Problematic"
}

export default function DiscriminationIndicator({
  discriminationIndex,
  discriminationLevel,
}: DiscriminationIndicatorProps) {
  const colorScheme = {
    Excellent: "green",
    Good: "blue",
    Poor: "yellow",
    Problematic: "red",
  }[discriminationLevel]

  const description = {
    Excellent: "Strongly distinguishes high vs low performers (>0.30)",
    Good: "Adequately distinguishes performers (0.10-0.30)",
    Poor: "Weakly distinguishes performers (0.00-0.10)",
    Problematic: "Low performers do better than high performers (<0.00)",
  }[discriminationLevel]

  return (
    <Card.Root h="full">
      <Card.Body>
        <Heading size="md" mb={4}>
          Discrimination
        </Heading>

        <VStack align="stretch" gap={4}>
          <HStack justify="space-between">
            <Text fontSize="2xl" fontWeight="bold">
              {discriminationIndex.toFixed(2)}
            </Text>
            <Badge colorScheme={colorScheme} fontSize="md" px={3} py={1}>
              {discriminationLevel}
            </Badge>
          </HStack>

          <Text fontSize="sm" color="gray.600">
            {description}
          </Text>

          <Text fontSize="xs" color="gray.500">
            Measures how well this question distinguishes between high and
            low-performing students
          </Text>

          {discriminationLevel === "Problematic" && (
            <Box
              bg="red.50"
              p={3}
              borderRadius="md"
              borderWidth={1}
              borderColor="red.200"
            >
              <Text fontSize="sm" color="red.700">
                ⚠️ This question may need review - low performers are answering
                better than high performers
              </Text>
            </Box>
          )}
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
